import styled from 'styled-components';

export const PolicyList = styled.ul`
    list-style-type: none;
    text-align: center;
    padding: 20px 0;
    font-size: 12px;
`;
